// The six position groups players are compared within, and the default minutes floor. Shared
// by the nightly Stats files (each player's "group" rows), the Bio tag and the Squad, so they
// all agree on who sits in which group. No AWS, no DOM.
//
// (Until T2-12b this file also held the old 02:00 job's percentile + leaderboard math; that job
// and its routes were deleted once the Stats tiles read the nightly files.)

/**
 * A peer POSITION GROUP — a SET of position_ids (Crux short codes), taken
 * verbatim from the old app's radar templates (soccer-frontend .../radar
 * `templates` → `PEER_GROUPS`), NOT the `/positions` endpoint's `group` field
 * (their memberships differ — radar splits Defender into centre_back + full_back
 * and folds wingers into attacking_midfielder). They are also the prototype's 6
 * position templates (Bio's tag) and the groups of Ben's Position chip.
 */
export interface PeerPositionGroup {
  id: string;
  positionIds: string[];
}

/** The six peer groups (a radar template with no positions is a UI overlay). */
export const PEER_POSITION_GROUPS: PeerPositionGroup[] = [
  { id: "striker", positionIds: ["RCF", "CF", "LCF"] },
  { id: "attacking_midfielder", positionIds: ["RW", "RAM", "CAM", "LAM", "LW"] },
  { id: "midfielder", positionIds: ["RDM", "CDM", "LDM", "RM", "RCM", "CM", "LCM", "LM"] },
  { id: "centre_back", positionIds: ["RCB", "CB", "LCB"] },
  { id: "full_back", positionIds: ["RB", "LB", "RWB", "LWB"] },
  { id: "goalkeeper", positionIds: ["GK"] },
];

/** Default minutes floor for the peer set — old Catalyst's default (verified). */
export const DEFAULT_MINUTES_FLOOR = 150;
